export const CONSTANTS = {
  SLUG: {
    configuration: 'configuration',
  },
}
